// Числовая шкала рангов LoL и средний ранг команды.
// Зеркало бэкенда (GoodLuck.Core/Common/RiotRankCompatibility.cs): tier*10 + division.
// Используется для клиентского расчёта «среднего Эло» на странице команды
// (список /rosters считает то же на бэке в RosterListItemDto.AverageRank).

const TIER_ORDER: Record<string, number> = {
  UNRANKED: 0,
  IRON: 1,
  BRONZE: 2,
  SILVER: 3,
  GOLD: 4,
  PLATINUM: 5,
  EMERALD: 6,
  DIAMOND: 7,
  MASTER: 8,
  GRANDMASTER: 9,
  CHALLENGER: 10,
};
const DIV_ORDER: Record<string, number> = { IV: 1, III: 2, II: 3, I: 4 };
const TIER_BY_IDX: Record<number, string> = Object.fromEntries(
  Object.entries(TIER_ORDER).map(([k, v]) => [v, k]),
);
const DIV_BY_IDX: Record<number, string> = Object.fromEntries(
  Object.entries(DIV_ORDER).map(([k, v]) => [v, k]),
);
const APEX = new Set(["MASTER", "GRANDMASTER", "CHALLENGER"]);

function parseRank(raw: string): { tier: string; div: string } {
  const u = (raw || "").toUpperCase().replace(/[_-]/g, " ").trim();
  for (const tier of [
    "CHALLENGER", "GRANDMASTER", "MASTER", "DIAMOND", "EMERALD",
    "PLATINUM", "GOLD", "SILVER", "BRONZE", "IRON",
  ]) {
    if (!u.includes(tier)) continue;
    if (APEX.has(tier)) return { tier, div: "I" };
    for (const div of ["IV", "III", "II", "I"]) {
      if (u.includes(` ${div}`) || u.endsWith(div)) return { tier, div };
    }
    return { tier, div: "IV" };
  }
  return { tier: "UNRANKED", div: "IV" };
}

export function rankToScore(raw: string): number {
  const { tier, div } = parseRank(raw);
  const t = TIER_ORDER[tier] ?? 0;
  let d = DIV_ORDER[div] ?? 0;
  if (APEX.has(tier)) d = 4;
  return t * 10 + d;
}

export function scoreToRank(score: number): string {
  const tierIdx = Math.min(10, Math.max(1, Math.round(score / 10)));
  const tier = TIER_BY_IDX[tierIdx] ?? "UNRANKED";
  if (APEX.has(tier)) return tier;
  const d = Math.min(4, Math.max(1, score - tierIdx * 10));
  return `${tier} ${DIV_BY_IDX[d] ?? "IV"}`;
}

/** Средний ранг команды по рангам участников (Unranked исключаются). null если рангов нет. */
export function averageRank(
  ranks: Array<string | null | undefined>,
): string | null {
  const scores = ranks
    .filter((r): r is string => Boolean(r && r.trim()))
    .map(rankToScore)
    .filter((s) => s >= 11); // исключаем Unranked (тир 0 → score 1..4)
  if (scores.length === 0) return null;
  const avg = Math.round(scores.reduce((a, b) => a + b, 0) / scores.length);
  return scoreToRank(avg);
}

/** "PLATINUM II" → "Platinum II" для отображения. */
export function prettyRank(rank: string): string {
  const [tier = "", div = ""] = rank.trim().split(/\s+/);
  const t = tier.charAt(0).toUpperCase() + tier.slice(1).toLowerCase();
  return div ? `${t} ${div}` : t;
}
